import type { ReactNode } from 'react';

import { Navigate } from 'react-router-dom';

import { paths } from '@/routes/paths';

import { useAuth } from './use-auth';

interface ProtectedRouteProps {
  children: ReactNode;
  fallback?: ReactNode;
}

// Guards routes that require authentication. While the bootstrap /api/me call is in
// flight, renders null. If unauthenticated, renders the supplied `fallback` or a
// default Navigate to the login page.

export function ProtectedRoute({ children, fallback }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;
  if (!user) return <>{fallback ?? <Navigate to={paths.auth.login} replace />}</>;
  return <>{children}</>;
}
